import { getContext } from "redux-saga/effects";

export const GETAPIHANDLER = "getApiHandler";

export default function* getApiHandler() {
  const apiHandlerFactory = yield getContext(GETAPIHANDLER);

  return apiHandlerFactory();
}
